import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-personal-settings-notifications/src/ui/__generated__/ui_NotificationsPageAndProjectQuery.graphql';

export const personalSettingsNotificationsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-personal-settings-notifications" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		// Queries your async component uses
		queries: {
			pageAndProject: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : [],
				},
			},
		},
		// Optional - Anything extra you wish to pass to your component
		// Something from `EntryPointParams` for example
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
		},
	}),
});
